<template>
  <div>
    <el-form :model="busData" style="margin-top: 10px;" label-width="160px" :inline="true">
      <!--      头部信息-->
      <el-row style="margin-left: 5%" class="compact-form">
        <el-col :span="12">
          <el-form-item label="工作日期：" style="width: 90%" required>
            <el-date-picker type="date" v-model="busData.work_date" style="width: 100%" @change="checkWorkDate()"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="本日总工时：" style="width: 90%" required>
            <el-input-number v-model="busData.total_hours" disabled style="width: 100%"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <!--      工作记录配置-->
      <el-row style="font-weight:bold;margin-bottom: 10px;margin-left: 10px;"><b>工作记录：</b></el-row>
      <el-row v-for="item in itemList" :key="item.nanoid">
        <div style="border: 1px solid #d9d9d9;width: 90%;min-height: 250px;margin-bottom: 20px;margin-left: 5%">
          <div class="item-top">
            <div style="width: 40%;padding-left: 20px;font-weight: bold;" >
              序号： {{item.serial_number}}
            </div>
            <div class="actions" >
<!--              <button v-if="item.serial_number  > 1" class="item-bottom" @click="moveUpItem(item.nanoid)">-->
<!--                <el-icon><Top/></el-icon>上移-->
<!--              </button>-->
<!--              <button v-if="item.serial_number  < itemList.length" class="item-bottom" @click="moveDownItem(item.nanoid)">-->
<!--                <el-icon><Bottom/></el-icon>下移-->
<!--              </button>-->
              <button v-if="item.serial_number > 1" class="item-bottom" @click="deleteItem(item.nanoid)">
                <el-icon><Delete/></el-icon>删除
              </button>
            </div>
          </div>
          <div style="width: 100%">
            <el-row style="margin-top: 5px" class="compact-form">
              <el-col :span="22" offset="1">
                <el-form-item label="工作简要：" style="width: 100%" required>
                  <el-input v-model="item.title" ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="22" offset="1">
                <el-form-item label="项目名称：" style="width: 100%">
                  <el-select v-model="item.project_id" clearable>
                    <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="22" offset="1">
                <el-form-item label="详情内容：" style="width: 100%" required>
                  <el-input v-model="item.work_content" type="textarea" :autosize="{ minRows: 2, maxRows: 5}"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11" offset="1">
                <el-form-item label="进度(%)：" style="width: 100%" required>
                  <el-input-number v-model="item.progress" style="width: 100%" :precision="1" :min="0.1" :max="100"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="11" offset="1">
                <el-form-item label="本项工时(h)：" style="width: 100%" required>
                  <el-input-number v-model="item.work_hour" style="width: 100%" :precision="1" :min="0.1" :max="24"
                                   @change="calcTotalHours">
                  </el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="22" offset="1">
                <el-form-item label="备注：" style="width: 100%">
                  <el-input v-model="item.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5}"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="22" offset="1">
                <el-form-item label="附件：" required style="width: 100%">
                  <kf-file-upload v-model="item.file_ids" @fileChange="fileChange(item,$event)" :limit="99" ></kf-file-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-row>
      <el-row>
        <el-button type="primary" plain @click="addOneItem(1)" style="margin-left: 10px">
          添加一项工作记录
        </el-button>
      </el-row>
    </el-form>
    <div style="margin: 20px">
      <el-row justify="center">
        <el-button type="primary" @click="workRecordAdd()">保存</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import {nanoid} from "nanoid";
import {Delete} from "@element-plus/icons-vue";
import {ElMessageBox} from "element-plus";

export default {
  name: "WorkRecordAdd",
  components: {Delete},
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      busData: {
        item_list: []
      },
      projectList:[],
      itemList:[],
    }
  },
  created() {
    this.getProjectList();
    this.addOneItem(1);
  },

  methods: {

    //获取当前用户所在的项目
    async getProjectList() {
      this.projectList = await this.$http('prjWorkRecordService.getMyProjectList');
    },

    //检查工作日期是否已存在
    async checkWorkDate() {
      if (this.busData.work_date) {
        if (this.busData.work_date > new Date()) {
          this.busData.work_date = '';
          return this.$message.error("工作日期不能超过今天");
        }
      }
      let date = await this.$http('prjWorkRecordService.checkWorkDate', this.busData);
      if (date){
        this.busData.work_date = '';
        return this.$message.error("该日期已存在工作记录");
      }
    },

    //获取总工时
    calcTotalHours(){
      let hours = 0;
      for (let i = 0; i < this.itemList.length; i++){
        hours += this.itemList[i].work_hour
      }
      this.busData.total_hours = hours
    },

    //添加一行工作记录
    addOneItem(cnt){
      for (let i = 0; i < cnt; i++){
        this.itemList.push({
          nanoid: nanoid(),
          serial_number: this.itemList.length + 1
        })
      }
    },

    //工作记录上移
    moveUpItem(nanoid){
      // let item = this.itemList;
      for (let i = 0; i < this.itemList.length; i++){
        if (this.itemList[i].nanoid === nanoid) {
          if (i > 0) {
            let temp = this.itemList[i];
            this.itemList[i] = this.itemList[i - 1];
            this.itemList[i - 1] = temp;
            this.itemList[i].serial_number = i + 1;
            this.itemList[i - 1].serial_number = i;
            break;
          }
        }
      }
    },

    //工作记录下移
    moveDownItem(nanoid){
      for (let i = 0; i < this.itemList.length; i++){
        if (this.itemList[i].nanoid === nanoid) {
          if (i < this.itemList.length - 1) {
            let temp = this.itemList[i];
            this.itemList[i] = this.itemList[i + 1];
            this.itemList[i + 1] = temp;
            this.itemList[i].serial_number = i + 1;
            this.itemList[i + 1].serial_number = i + 2 ;
            break;
          }
        }
      }
    },

    //删除工作记录
    deleteItem(nanoid){
      for (let i = 0; i < this.itemList.length; i++){
        if (this.itemList[i].nanoid === nanoid) {
          this.itemList.splice(i,1);
          for (let j = i; j < this.itemList.length; j++){
            this.itemList[j].serial_number = j + 1;
          }
          this.calcTotalHours();
          return
        }
      }
    },

    //保存
    async workRecordAdd() {
      if (!this.busData.work_date) {
        return this.$message.error("请选择工作日期");
      }
      if (this.itemList.length === 1 && !this.itemList[0].title){
        return this.$message.error("请填写工作记录");
      }

      for (let i = 0; i < this.itemList.length; i++){
        if (!this.itemList[i].title) {
          this.itemList.splice(i,1);
        } else {
          if (!this.itemList[i].work_content){
            return this.$message.error("请选择第【"+ this.itemList[i].serial_number +"】项的详情内容");
          }
          if (!this.itemList[i].progress){
            return this.$message.error("请填写第【"+ this.itemList[i].serial_number +"】项的进度(%)");
          }
          if (!this.itemList[i].work_hour){
            return this.$message.error("请填写第【"+ this.itemList[i].serial_number +"】项的本项工时(h)");
          }
          if (!this.itemList[i].file_ids){
            return this.$message.error("请添加第【"+ this.itemList[i].serial_number +"】项的附件");
          }
        }
      }
      if (this.itemList.length === 0){
        return this.$message.error("请填写工作记录");
      }
      if (this.busData.total_hours > 24) {
        return this.$message.error("本日总工时已超过24小时，请修改");
      }
      for (let i = 0; i < this.itemList.length; i++){
        this.itemList[i].serial_number = i + 1;
      }
      ElMessageBox.confirm(
          '你是否确认提交工作记录表',
          '提交表单',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        this.busData.item_list = this.itemList;
        await this.$http('prjWorkRecordService.addWorkRecord', this.busData)
        this.$message.success("保存成功")
        this.$fn.closeWindow();
        this.$fn.search();
      })
    },

    fileChange(item,ids) {
      if (ids.length <= 0) {
        item.file_ids = '';
      }else {
        item.file_ids = ids;
      }
    }


  }

}
</script>


<style scoped>

:deep(.el-input-number__decrease) {
  width: 20px;
}

:deep(.el-input-number__increase) {
  width: 20px;
}

:deep(.el-input-number.is-controls-right .el-input__wrapper) {
  padding: 0 20px 0 5px;
}

.item-top {
  width: 100%;
  height: 25px;
  border: 1px solid #d9d9d9;
  background-color: #e6e6e6;
  display:flex;
  justify-content: space-between;
  align-items: center
}

.actions {
  width: 60%;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

.item-bottom {
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fc0202;
  background-color: #e6e6e6
}

.compact-form .el-col {
  margin-bottom: 5px;
}

.compact-form .el-form-item {
  margin-bottom: 5px;
}

</style>
